export default __webpack_public_path__ + "static/1989-01-01_perception_ICMC.pdf";